var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [_vm._v(_vm._s(_vm.index + 1))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.rec_status_text))]),
    _vm._v(" "),
    _vm.status_type == 1 ? _c("td", [_vm._m(0)]) : _c("td", [_vm._m(1)]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.ogrn))]),
    _vm._v(" "),
    _c(
      "td",
      { staticStyle: { "font-weight": "700" } },
      [
        _c("a", _vm._b({ attrs: { target: "_blank" } }, "a", _vm.href, false), [
          _vm._v("\n            " + _vm._s(_vm.name_short) + "\n        "),
        ]),
        _vm._v(" "),
        _c("monitoring-set-delete-button", { attrs: { ogrn: _vm.ogrn } }),
      ],
      1
    ),
    _c("td", [_vm._v(_vm._s(_vm.date_start))]),
    _vm._v(" "),
    _c("td", [
      _vm.inn
        ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v("ИНН " + _vm._s(_vm.inn)),
            _c("br"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.okpo
        ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v("ОКПО " + _vm._s(_vm.okpo)),
            _c("br"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.kpp
        ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
            _vm._v("КПП " + _vm._s(_vm.kpp)),
            _c("br"),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("td", [
      _vm.okved_bool
        ? _c("div", [
            _vm._v(
              "\n            " +
                _vm._s(_vm.okved.code) +
                " – " +
                _vm._s(_vm.okved.descr) +
                "\n        "
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("td", [
      _vm.rukovod
        ? _c("div", [
            _vm.rukovod.position
              ? _c("span", [_vm._v(_vm._s(_vm.rukovod.position) + " ")])
              : _vm._e(),
            _vm._v(" "),
            _vm.rukovod.name
              ? _c("span", { staticStyle: { "font-weight": "700" } }, [
                  _vm._v(_vm._s(_vm.rukovod.name) + " "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.rukovod.inn
              ? _c("span", { staticStyle: { "white-space": "nowrap" } }, [
                  _vm._v("ИНН " + _vm._s(_vm.rukovod.inn)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "last-column" }, [
      _vm.address
        ? _c(
            "p",
            { staticClass: "address", staticStyle: { "font-weight": "700" } },
            [_vm._v(_vm._s(_vm.address))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.phones
        ? _c(
            "p",
            { staticStyle: { margin: "10px auto" } },
            _vm._l(_vm.phones, function (e, i) {
              return _c("span", { key: i, staticClass: "contact" }, [
                _vm._v(_vm._s(e)),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.emails
        ? _c(
            "p",
            { staticStyle: { margin: "10px auto" } },
            _vm._l(_vm.emails, function (e, i) {
              return _c("span", { key: i, staticClass: "contact" }, [
                _vm._v(_vm._s(e)),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sites
        ? _c(
            "p",
            { staticStyle: { margin: "10px auto" } },
            _vm._l(_vm.sites, function (e, i) {
              return _c(
                "a",
                { key: i, attrs: { target: "_blank", href: "//" + e } },
                [_vm._v(_vm._s(e))]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "#87D37C" } }, [
      _c("i", { staticClass: "lnr lnr-checkmark-circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { color: "#cc0000" } }, [
      _c("i", { staticClass: "lnr lnr-cross-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }